import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ElementMenuDashComponent } from "./components/element-menu-dash/element-menu-dash.component";
import { PlanViewComponent } from './components/plan-view/plan-view.component';
import { QuickMenuComponent } from "./components/quick-menu/quick-menu.component";
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { MainModule } from './modules/main/main.module';

@NgModule({
  declarations: [
    DashboardComponent,
    QuickMenuComponent,
    ElementMenuDashComponent,
    PlanViewComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MainModule,
    SharedModule
]
})
export class DashboardModule { }